<template>
  <div>
     <el-menu
        :default-active="activeMenu"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item  v-for="(route,index) in permission_routes" :key="index" :item="route" :base-path="route.path" />
      </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/sider.scss'

export default {
  components: { SidebarItem },
  data () {
    return {
      permission_routes: []
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'sidebar'
    ]),
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables () {
      return variables
    },
    showLogo () {
      return this.$store.state.settings.sidebarLogo
    }
  },
  created () {
    if (this.user.accountType == 1) {
      this.permission_routes = this.$store.getters.permission_routes.filter((item) => {
        return item.meta && item.meta.roles !== 'dsim'
      })
    } else {
      this.permission_routes = this.$store.getters.permission_routes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue